import React from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom'

//HELPERS
import * as c from './helpers/constants'

//REDUX
import { connect } from 'react-redux';

//COMPONENTS
import Error404 from './pages/error404';
import Login from './pages/login';
import RecuperarSenha from './pages/recuperarSenha';
import RedefinirSenha from './pages/redefinirSenha';
import Painel from './pages/painel';
import Campanha from './pages/campanha';
import Carimbo from './pages/carimbo';
import Relatorio from './pages/relatorio';
import ValidacaoEmail from './pages/validacaoEmail';
import ConfiguracaoUsuarios from './pages/configuracaoUsuarios';
import { isAuthenticated } from './store/auth';
import EnvioSms from './pages/envioSms'
import modulo from './components/carimboTempo/modulo';

class App extends React.Component
{
    constructor(props)
    {
        super(props);
    }

    getInitialRedirect(auth) {
        const path = this.props.location.pathname;

        if (!isAuthenticated()) {
            return path !== c.LOGIN_ROUTE ? <Redirect to={c.LOGIN_ROUTE} /> : null;
        }

        if (auth?.user?.primeiroAcesso) {
            return path !== c.TROCA_SENHA ? <Redirect to={c.TROCA_SENHA} /> : null;
        }

        return path !== c.DEFAULT_PRIVATE_ROUTE ? <Redirect to={c.DEFAULT_PRIVATE_ROUTE} /> : null;
    }

    render() 
    {
        const auth = this.props.auth;

        const PrivateRoute = ({ component: Component, ...rest }) => (            
            <Route {...rest} render={props => 
                isAuthenticated() ? (
                    props.location.pathname === "/login" ? (
                        <Component {...props} />
                    ) : auth?.user?.primeiroAcesso ? (
                        <Redirect to={c.TROCA_SENHA} />
                    ) : (
                        <Component {...props} />
                    )
                ) : (
                    <Redirect to={{ pathname: "/login", state: { from: props.location } }} />
                )
            }
            />
        );                      
        
        return (
            <Switch history={this.props.history}>
                <Route exact path="/">
                    <Redirect to={c.LOGIN_ROUTE} />
                </Route>


                <Route exact path={c.LOGIN_ROUTE}    component={Login} />
                <Route exact path={c.RECUPERAR_SENHA} component={RecuperarSenha} />
                <Route exact path={c.TROCA_SENHA}     component={RedefinirSenha} />
                
                <PrivateRoute exact path={c.PANEL_ROUTE}        component={Painel} />
                <PrivateRoute       path={c.CAMPAIGN_ROUTE}     component={Campanha} />
                <PrivateRoute       path={c.STAMP_ROUTE}        component={Carimbo} />
                <PrivateRoute       path={c.REPORT_ROUTE}       component={Relatorio} />
                <PrivateRoute exact path={c.VALIDATION_ROUTE}   component={ValidacaoEmail} />
                <PrivateRoute       path={c.REPORT_USUARIO}     component={ConfiguracaoUsuarios} />
                <PrivateRoute       path={c.ENVIO_SMS_ROUTE}    component={EnvioSms} />
                <PrivateRoute       path={c.MODULO}             component={modulo} />
                
                <PrivateRoute component={Error404} />
            </Switch>
        );    
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth };
}
function mapDispatchToProps(dispatch)
{
    return { };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
